/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  HomePiracyHomePiracyProtocolsAddNewRequestRequest,
  HomePiracyHomePiracyProtocolsGetCrDetailsRequest,
  HomePiracyHomePiracyProtocolsGetCrDetailsResponse,
  HomePiracyHomePiracyProtocolsGetCrHasNewBadgeResponse,
  HomePiracyHomePiracyProtocolsGetCrListCountRequest,
  HomePiracyHomePiracyProtocolsGetCrListCountResponse,
  HomePiracyHomePiracyProtocolsGetCrListRequest,
  HomePiracyHomePiracyProtocolsGetCrListResponse,
  HomePiracyHomePiracyProtocolsGetUploadUrlRequest,
  HomePiracyHomePiracyProtocolsGetUploadUrlResponse,
  HomePiracyHomePiracyProtocolsReportGetListResponse,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class HomePiracy<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags HomePiracy
   * @name PiracyCrListCreate
   * @request POST:/home/piracy/cr/list
   */
  piracyCrListCreate = (data: HomePiracyHomePiracyProtocolsGetCrListRequest, params: RequestParams = {}) =>
    this.http.request<HomePiracyHomePiracyProtocolsGetCrListResponse, any>({
      path: `/home/piracy/cr/list`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags HomePiracy
   * @name PiracyCrListCountCreate
   * @request POST:/home/piracy/cr/list/count
   */
  piracyCrListCountCreate = (data: HomePiracyHomePiracyProtocolsGetCrListCountRequest, params: RequestParams = {}) =>
    this.http.request<HomePiracyHomePiracyProtocolsGetCrListCountResponse, any>({
      path: `/home/piracy/cr/list/count`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags HomePiracy
   * @name PiracyCrDetailsCreate
   * @request POST:/home/piracy/cr/details
   */
  piracyCrDetailsCreate = (data: HomePiracyHomePiracyProtocolsGetCrDetailsRequest, params: RequestParams = {}) =>
    this.http.request<HomePiracyHomePiracyProtocolsGetCrDetailsResponse, any>({
      path: `/home/piracy/cr/details`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags HomePiracy
   * @name PiracyCrAddCreate
   * @request POST:/home/piracy/cr/add
   */
  piracyCrAddCreate = (data: HomePiracyHomePiracyProtocolsAddNewRequestRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/home/piracy/cr/add`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags HomePiracy
   * @name PiracyCrUploadUrlCreate
   * @request POST:/home/piracy/cr/upload-url
   */
  piracyCrUploadUrlCreate = (data: HomePiracyHomePiracyProtocolsGetUploadUrlRequest, params: RequestParams = {}) =>
    this.http.request<HomePiracyHomePiracyProtocolsGetUploadUrlResponse, any>({
      path: `/home/piracy/cr/upload-url`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags HomePiracy
   * @name PiracyCrNewList
   * @request GET:/home/piracy/cr/new
   */
  piracyCrNewList = (params: RequestParams = {}) =>
    this.http.request<HomePiracyHomePiracyProtocolsGetCrHasNewBadgeResponse, any>({
      path: `/home/piracy/cr/new`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags HomePiracy
   * @name PiracyPerformanceReportListList
   * @request GET:/home/piracy/performance/report/list
   */
  piracyPerformanceReportListList = (params: RequestParams = {}) =>
    this.http.request<HomePiracyHomePiracyProtocolsReportGetListResponse, any>({
      path: `/home/piracy/performance/report/list`,
      method: 'GET',
      format: 'json',
      ...params,
    });
}
